import { createBoxInstance } from '@stackhouseos/box-core';
import React from 'react';
import * as controls from './controls';
import {
	BoxComponentType,
	IBoxButtonComponent,
	IBoxComponent,
	IBoxFormComponent,
	IBoxSubmitComponent,
} from '@enuan/chat__utils';
import { Button } from '../UI/Button/Button';

const customBoxComponents: Record<
	BoxComponentType,
	React.FunctionComponent<any>
> = {
	...controls,
	Textarea: controls.TextareaBox,
	Button,
};

export const isInputComponent = (
	field: IBoxComponent,
): field is Exclude<
	IBoxFormComponent,
	IBoxSubmitComponent | IBoxButtonComponent
> =>
	![
		BoxComponentType.DIV,
		BoxComponentType.HTML,
		BoxComponentType.SUBMIT,
		BoxComponentType.BUTTON,
	].includes(field.type);

const _Box = createBoxInstance();
_Box.extendControls(customBoxComponents);

export const CustomBox = _Box;
